const columns = [
    {
        title: 'Account Holder Name',
        dataIndex: 'accountHolderName',
    },
    {
        title: 'Bank Name',
        dataIndex: 'bankName',
    },
    {
        title: 'IBAN No',
        dataIndex: 'ibanNo',
    },
    {
        title: 'Swift Code',
        dataIndex: 'swiftCode',
    },
    {
        title: 'Branch Address',
        dataIndex: 'branchAddress',
    },
    {
        title: 'Create Date',
        dataIndex: 'createdDate',
    },
    {
        title: 'Status',
        dataIndex: 'isActive',
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
    }
];


export default columns;